import { render, staticRenderFns } from "./TransferindDirection.vue?vue&type=template&id=e0d99a9a"
import script from "./TransferindDirection.vue?vue&type=script&lang=js"
export * from "./TransferindDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports